<template>
  <div class="fullWidth wrap fRow aStart jAround">
    <toast />
    <!-- card header -->
    <div class='fRow fullWidth jStart aStart'>
      <div class='growFull fCol jStart aStart'>
        <h3 class='growFull text-right'>{{ct}}</h3>
        <p class='note'>{{cd}}</p>
      </div>
    </div>
    <div class='sepLine' v-if='!this.isDelete'></div>
    <progress-bar w='100%' h='324px' msg='لطفا کمی صبر کنید'
      v-if="!fieldsReady && mode !== 'delete'"/>
    <error-bar w='100%' h='324px' :msg='msgError' v-if="!this.plsWait && loadError"/>
    <div class="fullWidth fRow aStart jBetween"
    v-if="fieldsReady && mode !== 'delete'">
      <div class="fCol jStart aStart half">
        <div class="inputWrapper fCol aStart jStart ptitle">
          <span>عنوان پایه‌ی تحصیلی</span>
          <input v-bind:class="{err: gradeTitleError}"
          placeholder="مثلا: «پایه‌ی اول»" type="text" v-model="gradeTitle"/>
        </div>
        <div class="fullWidth fRow jStart aStart wrap"
         v-bind:class="{err: gradeTitleError}" v-if="this.mode === 'add'">
          <p class="selectField"
          v-bind:class="{err: emptyError}"
          style="margin: 0 0 16px 0; width: 100%; text-align: right;">
            رشته/رشته‌های تحصیلی را انتخاب کنید
          </p>
          <!-- <label v-for="(item, index) in fields" v-bind:key="index"
            class="container checkBoxHolder dark"
            style="border: none; width: 33.333%">
            <input @change="selectField(index)" :id="`check${item.id}`"
            type="checkbox" :data-val="item.id"/>
            <span class="checkmark dark"></span>
            <span class="checkText fRow jCenter aCenter">
              <div>{{item.title}}</div>
            </span>
          </label> -->
          <div class="checkField fRow jStart aCenter w50"
            v-for="(item, index) in fields" v-bind:key="index"
            @click="selectField(index)"
            v-bind:class="{selected: selectedFields.includes(item.id)}">
            <i class="material-icons-round">
              {{!selectedFields.includes(item.id) ? 'radio_button_unchecked' : 'task_alt'}}</i>
            <span>{{item.title}}</span>
          </div>
        </div>
        <div class="inputWrapper fCol aStart jStart pState" style="margin-top: 16px;">
          <!-- <span>وضعیت</span> -->
          <div class="fullWidth fRow aCenter jCenter switchHolder" @click="changeState">
            <label style="margin-left: 16px;"
            class="growFull rtlText switchLabel">وضعیت نمایش</label>
            <switch-button :val='this.gradeSwitch' activeLabel='فعال' deactiveLabel='غیرفعال'/>
          </div>
        </div>
      </div>
      <div class="fCol jStart aStart" style="min-width: 330px">
        <div class="imgError"
        v-if="gradePhotoError">آپلود تصویر الزامیست</div>
        <get-photo
          w='100%'
          v-on:photoupload="getUploaded"
          photoFor='grade'
          :initImg='gradeInitPhoto'
          uploadMsg='آپلود تصویر الزامیست'
          uploadLabel='تصویر پایـه‌ی تحصیلی'/>
      </div>
    </div>
    <btn :label="this.cbl" btnWidth='70%' v-if='!this.isDelete && fieldsReady' class="flexGrow"
    :icon="this.cbi" @click.native="mainFunction"/>
    <!-- delete -->
    <div class="fullWidth wrap aStart jStart fRow btnRow"
    v-if="!this.plsWait && this.isDelete && !this.loadError">
      <btn label="بله، حذف شود" btnWidth='auto' bc='#ff0533'
      icon="delete_sweep" @click.native="deleteGrade"/>
      <btn label="نه" btnWidth='auto' bc='#aaaaaa' icon="close" @click.native="closeModal"/>
    </div>

  </div>
</template>

<script>
import axios from 'axios';
import Btn from '@/components/Btn.vue';
import SwitchButton from '@/components/SwitchButton.vue';
import ProgressBar from '@/components/ProgressBar.vue';
import ErrorBar from '@/components/ErrorBar.vue';
import Toast from '@/components/Toast.vue';
import GetPhoto from '@/components/GetPhoto.vue';
import errorHandler from '@/mixins/mixin';
import makeToast from '@/mixins/makeToast';

export default {
  mixins: [errorHandler, makeToast],
  data() {
    return {
      requestFields: [],
      gradeTitle: '',
      gradeSwitch: true,
      gradePhoto: '',
      gradeInitPhoto: '',
      gradeStatus: 1,
      peLocalPath: '',
      peServerPath: '',
      gradeTitleError: false,
      gradeFieldError: false,
      gradePhotoError: false,
      peIcon: '',
      peMethod: '',
      peHasChild: false,
      peState: 0,
      loadError: false,
      emptyError: false,
      msgError: false,
      showChild: this.childSwitch,
      parentDropDown: false,
      iconDropDown: false,
      stateDropDown: false,
      methodDropDown: false,
      isDataLoad: false,
      pArray: [],
      childSwitch: false,
      titleError: false,
      iconError: false,
      ct: '',
      cd: '',
      cbl: '',
      cbi: '',
      addMode: false,
      editMode: false,
      baseURL: this.$store.state.baseUrl,
      V: this.$store.state.apiVersion,
      modalStates: this.$store.state.modalState,
      plsWait: true,
      isDelete: false,
      // dynamic fields
      fields: [],
      fieldsReady: false,
      selectedFields: [],
    };
  },
  props: ['mode'],
  computed: {
    computedInitImage() {
      let cii = '';
      if (this.mode === 'add') {
        cii = 'none';
      } else if (this.mode === 'edit') {
        cii = this.gradeInitPhoto;
      }
      // alert(cii);
      return cii;
    },
  },
  methods: {
    getUploaded(value) {
      this.gradePhoto = value;
      this.gradePhotoError = false;
    },
    // selectField(event) {
    //   const fieldVal = parseInt(event.target.getAttribute('data-val'), 10);
    //   if (event.target.checked) {
    //     // inja bayad bbinim too add hastim ya edit
    //     if (this.mode === 'add') {
    //       if (!this.requestFields.includes(fieldVal)) {
    //         this.requestFields.push(fieldVal);
    //       }
    //     } else {
    //       // age edit bood
    //       for (let i = 1; i < 7; i += 1) {
    //         if (i !== fieldVal) {
    //           document.getElementById(`check${i}`).checked = false;
    //         }
    //       }
    //       this.requestFields = [];
    //       this.requestFields.push(fieldVal);
    //     }
    //   } else {
    //     if (this.requestFields.includes(fieldVal)) {
    //       this.requestFields.splice(this.requestFields.indexOf(fieldVal), 1);
    //     }
    //     console.log('');
    //   }
    //   console.error(this.requestFields);
    // },
    selectField(index) {
      const i = index;
      const [id] = [this.fields[i].id];
      const [idIndex] = [this.selectedFields.indexOf(id)];
      if (idIndex === -1) {
        this.selectedFields.push(id);
      } else {
        this.selectedFields.splice(idIndex, 1);
      }
      // console.log(this.selectedFields);
    },
    getParents() {
      this.isDataLoad = false;
      this.parentDropDown = false;
      axios({
        method: 'get',
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
        url: `${this.baseURL}/api/v${this.V}/Permissions`,
      }).then((response) => {
        this.loadError = false;
        this.parentDropDown = true;
        this.posts = response.data;
        document.getElementById('parent').focus();
        if (response.data.isSuccess) {
          this.isDataLoad = true;
          this.pArray = JSON.parse(JSON.stringify(this.posts));
        }
      }, (error) => {
        // console.log(error);
        this.msgError = this.errorHandler(error);
        this.loadError = true;
        this.makeToast('error', this.errorHandler(error), 2000);
      });
    },
    selectParent(value) {
      this.peParentId = value;
      setTimeout(() => {
        this.parentDropDown = false;
      }, 50);
    },
    closeParent() {
      setTimeout(() => {
        this.parentDropDown = false;
      }, 160);
    },
    getIcon() {
      document.getElementById('icon').focus();
      this.iconDropDown = true;
    },
    closeIcon() {
      setTimeout(() => {
        this.iconDropDown = false;
      }, 160);
    },
    selectIcon(value) {
      this.peIcon = value;
      setTimeout(() => {
        this.iconDropDown = false;
      }, 90);
    },
    getState() {
      this.stateDropDown = true;
    },
    closeState() {
      setTimeout(() => {
        this.stateDropDown = false;
      }, 160);
    },
    selectState(value) {
      this.peState = value;
      setTimeout(() => {
        this.stateDropDown = false;
      }, 90);
    },
    getMethod() {
      document.getElementById('method').focus();
      this.methodDropDown = true;
    },
    closeMethod() {
      setTimeout(() => {
        this.methodDropDown = false;
      }, 160);
    },
    selectMethod(value) {
      this.peMethod = value;
      setTimeout(() => {
        this.methodDropDown = false;
      }, 90);
    },
    gradeDataValidate() {
      if (this.gradeTitle === '') {
        this.gradeTitleError = true;
        this.makeToast('error', 'عنوان پایه‌‌ی تحصیلی را وارد کنید', 3000);
        return false;
      }
      this.gradeTitleError = false;
      if (this.mode === 'add') {
        if (this.selectedFields.length === 0) {
          this.makeToast('error', 'حداقل یک رشته‌ی تحصیلی را انتخاب کنید', 3000);
          this.gradeFieldError = true;
          return false;
        }
      }
      this.gradeFieldError = false;
      // اینجا باید تعریف کنیم اگه اینپوت عکس خالی بود نال بفرسته
      if (this.gradePhoto === '') {
        this.gradePhotoError = true;
        this.makeToast('error', 'تصویر پایه‌ی تحصیلی را آپلود کنید', 3000);
        return false;
      }
      this.gradePhotoError = false;
      return true;
    },
    returnState() {
      let x = 1;
      if (!this.stateSwitch) {
        x = 2;
      }
      return x;
    },
    returnHasChild() {
      return this.childSwitch;
    },
    postGrade() {
      if (this.gradeDataValidate()) {
        axios({
          method: 'post',
          url: `${this.baseURL}/api/v${this.V}/Grades/`,
          headers: {
            Authorization: this.$authObeject.authToken(),
          },
          data: {
            title: this.gradeTitle,
            photo: this.gradePhoto,
            fields: this.selectedFields,
            status: this.gradeSwitch,
          },
        }).then((response) => {
          // console.log('JAVAB', response);
          if (response.data.isSuccess) {
            this.$store.commit('closeCard');
            this.changeMsg();
            this.makeToast('success', 'پایه‌ تحصلیلی مورد نظر با موفقیت اضافه شد', 2000);
          }
        }, (error) => {
          this.makeToast('error', this.errorHandler(error), 2000);
        });
      }
    },
    editGrade() {
      // consolee.log('start edit permission');
      this.gradeDataValidate();
      // console.log('child switch', this.childSwitch);
      axios({
        method: 'put',
        url: `${this.baseURL}/api/v${this.V}/Grades/${this.$store.state.focusedGradeId}`,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
        data: {
          Title: this.gradeTitle,
          Photo: this.gradePhoto,
          Status: this.gradeSwitch,
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.$store.commit('closeCard');
          this.changeMsg();
          this.makeToast('success', 'پایه تحصیلی مورد نظر با موفقیت ویرایش شد', 2000);
        }
      }, (error) => {
        this.makeToast('success', this.errorHandler(error), 2000);
        // console.log(error);
      });
    },
    changeMsg() {
      this.$emit('changeMsg', 'hey');
      // console.log('message emit from child component');
    },
    mainFunction() {
      switch (this.mode) {
        case 'add': {
          this.postGrade();
          break;
        }
        case 'edit': {
          this.editGrade();
          break;
        }
        default:
          break;
      }
    },
    deleteGrade() {
      axios({
        method: 'delete',
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
        url: `${this.baseURL}/api/v${this.V}/Grades/${this.$store.state.focusedGradeId}`,
      }).then((response) => {
        // console.log('delete', response);
        if (response.data.isSuccess) {
          this.$store.commit('closeCard');
          this.changeMsg();
          this.makeToast('success', 'پایه‌ی تحصیلی مورد نظر با موفقیت حذف شد', 2000);
        } else {
          this.$store.commit('closeCard');
          this.makeToast('error',
            'برای این پایه تحصیلی درس ثبت شده است امکان حذف وجود ندارد', 5000);
        }
      }, (error) => {
        // console.log(error);
        this.makeToast('error', this.errorHandler(error), 2000);
      });
    },
    closeModal() {
      this.$store.commit('closeCard');
    },
    changeState() {
      this.gradeSwitch = !this.gradeSwitch;
      // consolee.log(this.stateSwitch);
    },
    changeChildState() {
      this.childSwitch = !this.childSwitch;
      // console.log(this.childSwitch);
    },
    notAllow(inp) {
      // alert(inp);
      switch (inp) {
        case 'method': {
          this.peMethod = this.peMethod.slice(0, this.peMethod.length - 1);
          break;
        }
        case 'icon': {
          this.peIcon = this.peIcon.slice(0, this.peIcon.length - 1);
          break;
        }
        case 'parent': {
          this.peParentId = this.peParentId.slice(0, this.peParentId.length - 1);
          break;
        }
        default:
          break;
      }
    },
    getFields() {
      const reqUrl = `${this.baseURL}/api/v${this.V}/Fields`;
      // if (f !== -1) {
      //   reqUrl = `${this.baseURL}/api/v${this.V}/Grades?field=${f}`;
      // }
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        this.fieldsReady = true;
        // JSON responses are automatically parsed.
        this.posts = response.data;
        if (this.posts.isSuccess) {
          // اگه درست بود همه چی
          this.fields = JSON.parse(JSON.stringify(this.posts.data));
          if (this.posts.data.length === 0) {
            this.responseEmpty = true;
            this.makeToast('warning', 'برای ثبت پایه ابتدا رشته‌های تحصیلی را ثبت کنید', 3000);
            this.closeModal();
          } else {
            this.responseEmpty = false;
          }
        } else {
          this.responseFalse = true;
          this.closeModal();
          this.makeToast('warning', 'خطا در دریافت رشته ها', 3000);
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        this.closeModal();
        // console.log(error);
      });
    },
  },
  components: {
    Btn,
    SwitchButton,
    ProgressBar,
    ErrorBar,
    Toast,
    GetPhoto,
  },
  mounted() {
    this.$nextTick(() => {
      switch (this.mode) {
        case 'add': {
          this.getFields();
          this.isDelete = false;
          this.ct = 'اضافه کردن پایه‌ی تحصیلی';
          this.cd = 'فرم زیر را تکمیل کنید';
          this.cbl = 'اضافه کردن پایه تحصیلی';
          this.cbi = 'add';
          this.gradePhoto = '';
          this.addMode = true;
          this.editMode = false;
          this.plsWait = false;
          // console.clear();
          break;
        }
        case 'edit': {
          this.getFields();
          // console.log('edit');
          this.isDelete = false;
          this.ct = 'ویرایش پایه‌ی تحصیلی';
          this.cd = 'اطلاعات زیر را ویرایش و ذخیره کنید';
          this.cbl = 'ثبت تغییرات';
          this.cbi = 'save';
          this.addMode = false;
          this.editMode = true;
          axios({
            method: 'get',
            headers: {
              Authorization: this.$authObeject.authToken(),
            },
            url: `${this.baseURL}/api/v${this.V}/Grades/${this.$store.state.focusedGradeId}`,
          }).then((response) => {
            // consolee.log('from permission manager in edit mode →', response.data.data.id);
            if (response.data.isSuccess) {
              this.gradeTitle = response.data.data.title;
              this.gradeInitPhoto = response.data.data.photo;
              this.gradePhoto = response.data.data.photo;
              this.requestFields = response.data.data.field;
              // setTimeout(() => {
              //   document.getElementById(`check${response.data.data.field}`).click();
              // }, 400);
              this.gradeSwitch = response.data.data.status;
            }
            this.plsWait = false;
            // console.log(this.gradePhoto);
          }, (error) => {
            // console.log(error);
            this.plsWait = false;
            this.makeToast('error', this.errorHandler(error), 2000);
          });
          break;
        }
        case 'delete': {
          this.plsWait = false;
          this.isDelete = true;
          this.ct = `آیا از حذف پایه‌ی «${this.$store.state.focusGradeName}» مطمئن هستید؟`;
          this.cd = 'این عملیات قابل بازیابی نیست.';
          break;
        }
        default:
          break;
      }
    });
  },
};
</script>

<style lang='scss' scoped>
.inputWrapper{
    margin-bottom: 24px;
    position: relative;
}
.inputWrapper span{
    font-size: 10px;
    padding-right: 8px;
    margin-bottom: 8px;
}

.inputWrapper input, .dropDownBtn{
    border: solid 2px rgba($color: #000000, $alpha: 0.2);
    border-radius: 4px;
    width: 100%;
    padding: 0px 12px;
    position: relative;
    height: 40px;
    transition: all ease-in-out 0.3s;
}

.dropDownBtn{
  width: 100%;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.inputValue{
  font-size: 14px;
  text-align: right;
}

.inputWrapper .hide{
  opacity: 0;
  transform: scale(0);
}

.inputWrapper input:focus{
    border: solid 2px rgba($color: #000000, $alpha: 0.4);
    outline: none;
    border-radius: 8px;
    width: 100%;
    padding: 8px 12px;
}

.inputWrapper .dropDown{
    position: absolute;
    top: calc(24px - 0px);
    left: -8px;
    right: -8px;
    overflow-x: hidden;
    overflow-y: auto;
    max-height: 264px;
    background-color: white;
    box-shadow: 0 8px 32px 0 rgba($color: #000000, $alpha: 0.25);
    border-radius: 8px;
    z-index: 300;
}

.inputWrapper .err {
  border-color: red;
  color: red;
}

.inputWrapper .dropDown .item{
    padding: 12px 16px;
    font-size: 14px;
    font-weight: 200;
    color: black;
    text-align: right;
    cursor: pointer;
    transition: all ease-in-out 0.3s;
}

.item.icon{
    width:  25% !important;
    height: 40px !important;
    display: flex;
    border-radius: 80px;
    justify-content: center;
    align-items: center;
    font-size: 24px !important;
}

.inputWrapper .dropDown .item:hover{
    background-color: rgba($color: #000000, $alpha: 0.05);
    color: #61187A;
}

.ptitle, .pParentId{
  width: 50%;
  min-width: 216px;
}

.imgError{
  border: sodlid 2px red;
  background-color: rgb(177, 15, 15);
  font-size: 14px;
  font-weight: 700;
  color: white;
  width: 100%;
  border-radius: 4px;
  text-align: right;
  padding: 8px 16px;
}

.pPath{
    width: calc(25% - 8px);
}
.pIcon{
    width: calc(25% - 8px);
}
.pState{
    width: auto
}
.pMethod{
    width: calc(25% - 8px);
}
.pHasChild{
    width: calc(60% - 8px);
}

.switchHolder{
  cursor: pointer;
}

.switchLabel{
  font-size: 12px;
  font-weight: 300;
  pointer-events: none;
}

.btnRow{
  margin-top: 16px;
}

.half {
  flex-grow: 1;
}

p.selectField{
  font-size: 14px;
  font-weight: 300;
}
// new styles
.checkField {
  padding: 8px 0;
  cursor: pointer;
  * {
    pointer-events: none;
  }
  i {
    margin-left: 8px;
  }
  span {
    font-size: 14px;
    font-weight: 300;
  }
}
.checkField.selected {
  i {
    margin-left: 8px;
    color: rgb(41, 138, 41);
  }
  span {
    font-size: 14px;
    font-weight: bold;
  }
}
</style>
